import { BasicBlock, ItemStatus } from "../../types/block/enum";
import { BlockType } from "../../types/block/type";
import { getDayBoundaries } from "../../utils/date-format/dateUtils";
import { inboxQueryKeys } from "../../react-query/inbox/queries";

const useFindUpdateInboxQueryKey = () => {
  const inboxGeneralQueryKey = inboxQueryKeys.inboxGeneral();
  const inboxCompletedQueryKey = inboxQueryKeys.inboxCompleted();
  const inboxOverdueQueryKey = inboxQueryKeys.inboxOverdue();
  const todayGeneralQueryKey = inboxQueryKeys.todayGeneral();

  const findUpdateInboxQueryKey = (updateBlock: BlockType) => {
    const TODAY = new Date();
    const { START_OF_DAY, END_OF_DAY } = getDayBoundaries({ day: TODAY, isAllday: true });

    // inbox는 TASK, DIVIDER에만 해당하므로 EVENT는 얼리 리턴
    if (updateBlock.blockType === BasicBlock.EVENT) {
      return null;
    }

    // Completed TASK
    if (updateBlock.itemStatus === ItemStatus.COMPLETED) {
      return inboxCompletedQueryKey;
    }

    // Inbox general TASK
    if (!updateBlock.start || !updateBlock.end) {
      return inboxGeneralQueryKey;
    }

    // Overdue TASK (end 날짜가 todayStart 이전인 경우)
    const isOverdue = new Date(updateBlock.end).getTime() <= new Date(START_OF_DAY).getTime();
    if (isOverdue) {
      return inboxOverdueQueryKey;
    }

    // Today General TASK (end 날짜가 TODAY_START 이후 && start 날짜가 TOMORROW_START(END_OF_DAY) 이전인 경우)
    const isTodayGeneral =
      new Date(START_OF_DAY).getTime() < new Date(updateBlock.end).getTime() &&
      new Date(updateBlock.start).getTime() < new Date(END_OF_DAY).getTime();

    if (isTodayGeneral) {
      return todayGeneralQueryKey;
    }

    // 위 조건에 해당하지 않는 경우 null 반환
    return null;
  };

  // 두 블록의 쿼리 키가 동일한지 비교하는 함수 추가
  const isSameInboxQueryKey = (
    queryKey1: ReturnType<(typeof inboxQueryKeys)[keyof typeof inboxQueryKeys]> | null,
    queryKey2: ReturnType<(typeof inboxQueryKeys)[keyof typeof inboxQueryKeys]> | null
  ) => {
    if (!queryKey1 || !queryKey2) {
      return false;
    }

    // 두 쿼리 키가 동일한지 비교
    return JSON.stringify(queryKey1) === JSON.stringify(queryKey2);
  };

  return {
    findUpdateInboxQueryKey,
    isSameInboxQueryKey,
  };
};

export default useFindUpdateInboxQueryKey;
